import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import React, { useEffect, useState } from 'react';
import { TabItemContext, useCreateTabItem } from '@tencent/glue-react-tabs';
import { withViewComponent } from '../../hoc/withViewComponent';
export var ViewTabsItem = withViewComponent(function ($p, $s, $c, $a) {
  var id = $p.id,
      _$p$disabled = $p.disabled,
      disabled = _$p$disabled === void 0 ? false : _$p$disabled,
      title = $p.title,
      children = $p.children;

  var _useCreateTabItem = useCreateTabItem({
    disabled: disabled,
    title: title,
    id: id
  }),
      tabItem = _useCreateTabItem.tabItem,
      itemDisabled = _useCreateTabItem.disabled,
      active = _useCreateTabItem.active;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setLoaded = _useState2[1];

  useEffect(function () {
    if (isLoaded || !active) {
      return;
    }

    setLoaded(true);
  }, [active]);
  return React.createElement(TabItemContext.Provider, {
    value: tabItem
  }, React.createElement("div", _objectSpread({
    className: $c(true, {
      disabled: itemDisabled,
      active: active
    }),
    style: $s
  }, $a), (isLoaded || active) && children));
}, 'tabs-item', ['disabled', 'title', 'closable', 'id', 'classNames', 'style', 'children']);